import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=7f8d6d1c&scoped=true"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountForm.vue?vue&type=style&index=0&id=7f8d6d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d6d1c",
  null
  
)

export default component.exports